function setCookie(name, value, days) {
  var d = new Date();
  d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
  document.cookie = name + "=" + encodeURIComponent(value) + "; expires=" + d.toUTCString() + "; path=/";
}
function getCookie(name) {
  var n = name + "=";
  var parts = document.cookie.split(';');
  for (var i = 0; i < parts.length; i++) {
    var c = parts[i].trim();
    if (c.indexOf(n) === 0) return decodeURIComponent(c.substring(n.length, c.length));
  }
  return "";
}
function lastPathPart(url) {
  try {
    var u = new URL(url, window.location.origin);
    var p = u.pathname || '';
    if (p.length > 1 && p.endsWith('/')) p = p.slice(0, -1);
    var seg = p.split('/').filter(Boolean);
    return (seg[seg.length - 1] || '').toLowerCase();
  } catch (e) {
    var p2 = (url || '').split('?')[0].split('#')[0] || '';
    if (p2.length > 1 && p2.endsWith('/')) p2 = p2.slice(0, -1);
    var seg2 = p2.split('/').filter(Boolean);
    return (seg2[seg2.length - 1] || '').toLowerCase();
  }
}
function isEn() {
  return (window.location.pathname || '').toLowerCase().indexOf('/en/') >= 0;
}
function getHandleLikeOld() {
  var path = (window.location.pathname || '').toLowerCase();
  if (path.endsWith('/')) path = path.slice(0, -1);
  var parts = path.split('/').filter(Boolean);
  return (parts[parts.length - 1] || '');
}
function normalizeParentFromHref(hrefLower) {
  if (!hrefLower) return '';
  if (hrefLower.indexOf('homme') >= 0 || hrefLower.indexOf('/men') >= 0) return 'men';
  if (hrefLower.indexOf('femme') >= 0 || hrefLower.indexOf('/women') >= 0) return 'women';
  return '';
}
function pickDefaultCurrentItem(lastVisited, currentParent) {
  var en = isEn();
  if (currentParent === 'women') return en ? 'WOMEN' : 'FEMMES';
  if (currentParent === 'men') return en ? 'MEN' : 'HOMMES';
  var last = (lastVisited || '').toLowerCase();
  if (last && !document.querySelector('.site-nav--megamenu .currentLink')) {
    if (last.indexOf('femme') >= 0 || last.indexOf('femmes') >= 0 || last.indexOf('women') >= 0) return en ? 'WOMEN' : 'FEMMES';
    if (last.indexOf('homme') >= 0 || last.indexOf('hommes') >= 0 || last.indexOf('men') >= 0) return en ? 'MEN' : 'HOMMES';
  }
  return en ? 'MEN' : 'HOMMES';
}
(function() {
  var href = window.location.href;
  var last = getCookie('last-visited');
  var body = document.body;
  var isIndex = body && body.classList && body.classList.contains('template-index');
  var path = (window.location.pathname || '').toLowerCase();
  var isWomen = path.indexOf('/pages/women') >= 0 || path.indexOf('/pages/femme') >= 0 || path.indexOf('/pages/femmes') >= 0;
  var isMen = path.indexOf('/pages/men') >= 0 || path.indexOf('/pages/homme') >= 0 || path.indexOf('/pages/hommes') >= 0;
  if (isWomen || isMen) {
    setCookie('last-visited', href, 30);
    return;
  }
  if (isIndex && last && last !== href) {
    var lastPath = '';
    try {
      lastPath = new URL(last, window.location.origin).pathname || '';
    } catch (e) {
      lastPath = last.split('?')[0].split('#')[0] || '';
    }
    if (lastPath && lastPath !== '/' && lastPath !== window.location.pathname) {
      window.location.replace(last);
    }
  }
})();
document.addEventListener('DOMContentLoaded', function() {
  var navs = Array.prototype.slice.call(document.querySelectorAll('.site-navigation--meganav'));
  if (!navs.length) return;
  var currentLink = lastPathPart(window.location.href);
  var allNavLinks = Array.prototype.slice.call(document.querySelectorAll('.site-navigation .site-nav__link, .site-navigation .site-nav__dropdown-link'));
  for (var i = 0; i < allNavLinks.length; i++) {
    var linkSeg = lastPathPart(allNavLinks[i].href);
    if (linkSeg && linkSeg === currentLink) {
      var expanded = allNavLinks[i].closest ? allNavLinks[i].closest('.site-nav__expanded-item') : null;
      if (expanded) expanded.classList.add('currentLink');
      break;
    }
  }
  var currentParent = '';
  var currentLinkInMega = document.querySelector('.site-nav--megamenu .currentLink');
  if (currentLinkInMega) {
    var mega = currentLinkInMega.closest ? currentLinkInMega.closest('.site-nav--megamenu') : null;
    if (mega && mega.previousElementSibling && mega.previousElementSibling.href) {
      currentParent = normalizeParentFromHref(mega.previousElementSibling.href.toLowerCase());
    }
  }
  var lastVisited = getCookie('last-visited');
  var currentItem = pickDefaultCurrentItem(lastVisited, currentParent);
  var newcurlocation = getHandleLikeOld();
  function getTopMegaItems() {
    return Array.prototype.slice.call(document.querySelectorAll('.site-navigation--meganav>li.site-nav__item.site-nav__has-megamenu'));
  }
  function clearCurrent(items) {
    for (var k = 0; k < items.length; k++) items[k].classList.remove('current');
  }
  function setCurrentByText(items) {
    for (var k = 0; k < items.length; k++) {
      var a = items[k].querySelector('.site-nav__link');
      if (!a) continue;
      if ((a.textContent || '').trim().toUpperCase() === currentItem) {
        items[k].classList.add('current');
        return true;
      }
    }
    return false;
  }
  function setCurrentByUrl(items) {
    for (var k = 0; k < items.length; k++) {
      var a = items[k].querySelector('.site-nav__link');
      if (!a || !a.href) continue;
      if (newcurlocation && a.href.toLowerCase().indexOf('/' + newcurlocation) >= 0) {
        items[k].classList.add('current');
        return true;
      }
    }
    return false;
  }
  function applyCurrentState() {
    var items = getTopMegaItems();
    clearCurrent(items);
    if (!setCurrentByUrl(items)) setCurrentByText(items);
  }
  var topMegaItems = getTopMegaItems();
  for (var t = 0; t < topMegaItems.length; t++) {
    (function(el) {
      el.addEventListener('mouseover', function() {
        var items = getTopMegaItems();
        clearCurrent(items);
        el.classList.add('current');
      });
    })(topMegaItems[t]);
  }
  for (var n = 0; n < navs.length; n++) {
    (function(navRoot) {
      navRoot.addEventListener('mouseleave', function() {
        applyCurrentState();
      });
    })(navs[n]);
  }
  applyCurrentState();
});
document.addEventListener('DOMContentLoaded', function() {
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  var detailsEls = document.querySelectorAll('[data-section-type="header"] .site-nav--megamenu details.site-nav__details[data-hover="true"]');
  if (!detailsEls.length) return;
  function closeOthers(current) {
    for (var i = 0; i < detailsEls.length; i++) {
      var d = detailsEls[i];
      if (d === current) continue;
      if (d.hasAttribute('open')) {
        d.removeAttribute('open');
        d.setAttribute('aria-expanded', 'false');
        var s = d.querySelector('summary[aria-expanded]');
        if (s) s.setAttribute('aria-expanded', 'false');
      }
    }
  }
  for (var j = 0; j < detailsEls.length; j++) {
    (function(d) {
      d.addEventListener('mouseover', function() { closeOthers(d); });
      d.addEventListener('focusin', function() { closeOthers(d); });
    })(detailsEls[j]);
  }
});
